/* eslint-disable no-unreachable */
import React from "react";
import { getQueryParams } from "../../../library/helpers";
import { CUSTOM } from "../../../constant/ReportConstants";

/**
 *
 * @param {Function} setactiveKeys SetState function
 * @param {Int} index Panel index
 * @param {Function} handler create/update handler, with complete payload
 */
export const handleSaveMessage = async (setactiveKeys, index, handler) => {
  const res = await handler();
  if (res) {
    setactiveKeys(prev => prev.filter(item => item !== index));
  }
};
export function removeHtmlTags(input) {
  return input?.replace(/<[^>]*>/g, "");
}
